<template>
  <div>
    <b-progress
      :value="100"
      show-progress
      class="mb-3"
      variant="blue"
    ></b-progress>
    <div class="row ml-0 mr-0">
      <b-col xs="12" sm="12" md="12" lg="12" xl="2" cols="12"></b-col>
      <b-col xs="12" sm="12" md="12" lg="12" xl="8" cols="12">
        <div class="container text-justify" ref="PDFText">
          <h6>Dealership Authorization of an Individual</h6>
          <div class="row text-size-10">
            <div class="col-md-6">
              Dealership Name:
              <span>
                <u>
                  {{ form.signatoryFirstName }} {{ form.signatoryLastName }}</u
                ></span
              >
            </div>
          </div>
          <p>
            Subject to our acceptance of this authorization, you acknowledge the
            following: (i) the capacities in which the Individual is authorized
            as your agent apply at and with us our subscribing AuctionACCESS
            customers (“Customers”), including affiliates; (ii) the
            authorization will be valid until one business day after we receive
            and process your written notice of termination in the form of a
            Dealer Removal Letter; and (iii) once processed, the most recent
            authorization received and accepted by us will replace any prior
            authorization(s) for the Individual for transactions thereafter.
          </p>
          <p>
            If you designate the Individual in the capacity of “Representative”,
            “Owner”, or “Officer/Manager” in this form, the Individual may buy
            and sell automobiles for you and execute company checks, drafts,
            certificates of title, and/or any other instruments or documents on
            your behalf at or with any Customer. You are responsible for any use
            of such Individual’s AuctionACCESS ID on your account. All
            categories, including “Drivers”, may pick up, receive, and/or
            deliver cars of other property on or for your account.
          </p>
          <p>
            You guarantee performance of all obligations and payment of all
            debts incurred or authorized by this Individual on your account with
            us or any Customer. This guaranty includes but is not limited to
            payment of losses from dishonored checks or drafts, defective
            titles, or false or inaccurate Odometer Mileage Statements. You also
            guarantee that the Individual will honor the AutoTec Terms and
            Conditions (as they may be amended from time to time and posted on
            www.AuctionACCESS.com), conduct business with us and our Customers
            in a fair and ethical manner, honoring all policies and procedures
            of each and respecting decisions of ours or our Customers with
            respect to same. You will indemnify and hold harmless Customers,
            AutoTec, LLC, each’s affiliates, and the officers, directors,
            employees, and agents of each of the foregoing, against any
            liability, loss, damages (including punitive damages), claim,
            settlement payment, cost, expense, award judgment, fee, or other
            charge, including reasonable attorneys’ fees, arising out of or
            relating to the authorized Individual’s actions, as well as any
            expense incurred in attempting to collect such losses, including
            attorney fees.
          </p>
          <p>
            Our Customers are third-party beneficiaries of this authorization
            agreement. At their election, and in their sole discretion, they may
            avail themselves of any provision of this agreement. However, this
            document is a supplement to, and not a replacement of modification
            of, any agreement you have with those Customers, or any policies and
            procedures of such Customer. AuctionACCESS and Customers each
            retains the right to stop doing business with this Individual as it
            sees fit.
          </p>
          <p>
            Sign:
            <u class="sign">
              <img
                v-if="signImage"
                :src="signImage"
                class="sign"
                alt=""
                @click="gotoSignature()"
              />

              <button v-if="!signImage" @click="gotoSignature()">sign</button>
            </u>
          </p>
          <p>
            {{ piedPage }}
          </p>
        </div>
      </b-col>

      <b-col xs="12" sm="12" md="12" lg="12" xl="2" cols="12"></b-col>
    </div>
    <b-row class="mr-0 ml-0">
      <b-col sm="12" md="4" lg="4" xl="4" class="mb-4"> </b-col>
      <b-col sm="12" md="6" lg="4" xl="4" class="mb-4">
        <b-button
          block
          class="btn btn-light-blue text-white"
          :disabled="!signImage"
          @click="generatePDF"
        >
          Envoye
          <b-spinner
            v-if="contract.status == 'fetching' ? true : false"
            small
            variant="white"
          ></b-spinner>
        </b-button>
      </b-col>
      <b-col sm="12" md="4" lg="4" xl="4" class="mb-4"> </b-col>
    </b-row>
    <!--  <div class="text-center">
      <button class="btn btn-danger mb-4" @click="generatePDF">Envoye</button>
    </div> -->
    <b-modal
      centered
      ref="emailModal"
      id="emailModal"
      size="md"
      hide-header-close
      hide-header
      hide-footer
      body-class="pl-0 pr-0"
    >
      <div class="text-center p-5">
        <p>
          <b-icon font-scale="5" icon="envelope"></b-icon>
        </p>
        <h5>
          Nous avons envoyé un lien de confirmation à l'adresse e-mail saisie
        </h5>
        <b-btn
          size="lg"
          class="btn-main mt-2"
          @click="
            $bvModal.hide('emailModal');
            goTo();
          "
          >Accepter
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { generalMixin } from "@/modules/mixin.js";
import { mapState } from "vuex";
import { GET_SERVER_TIME, GET_COMPANY, POST_CONTRACT } from "./actions";

export default {
  mixins: [generalMixin],

  props: {
    userItem: {},
  },
  data() {
    return {
      sign: "",
      font: "",
      form: {},
      modalPDF: false,
      piedPage: "",
      name: "Jorge Luca Anton Juarez",
      isPrint: false,
      token: null,
      serverTime: "",
    };
  },
  computed: {
    ...mapState({
      signImage: (state) => state.dealership.document.sign,
      contract: (state) => state.dealership.document.contract,
    }),
  },
  methods: {
    async generatePDF() {
      this.isPrint = true;
      const payload = await this.formatPayload();
      this.$store
        .dispatch(POST_CONTRACT, payload)
        .then((response) => {
          this.$refs["emailModal"].show();
        })
        .catch(() => {
          this.$toast.add({
              summary: this.$t('toast_title_error'),
              detail: this.$t('toast_message_error'),
              severity: "error",
              life: 5000
          })
        });

      this.isPrint = true;
    },

    async setPiedPage() {
      let browser = this.getBrowserInfo();
      let ipBrowser = await this.getIp();
      this.piedPage =
        browser + " " + ipBrowser + " " + navigator.language + " ";
    },
    async getIp() {
      let ipAdress;
      await fetch("https://api.ipify.org?format=json", {})
        .then((x) => x.json())
        .then(({ ip }) => {
          ipAdress = ip;
        });
      return ipAdress;
    },

    getBrowserInfo() {
      var ua = navigator.userAgent,
        tem,
        M =
          ua.match(
            /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
          ) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return "IE " + (tem[1] || "");
      }
      if (M[1] === "Chrome") {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
      return M.join(" ");
    },

    getServerTime() {
      let serverTime;
      this.$store
        .dispatch(GET_SERVER_TIME)
        .then((response) => {
          serverTime = response;
          return serverTime.data;
        })
        .catch((error) => {
          this.$toast.add({
              summary: this.$t('toast_title_error'),
              detail: this.$t('toast_message_error'),
              severity: "error",
              life: 5000
          })
        });
      return serverTime;
    },

    gotoSignature() {
      this.$router.push({
        name: "dealership.signature",
        params: { token: this.$route.params.token },
      });
    },
    async formatPayload() {
      let payload = {
        name: this.form.signatoryFirstName + " " + this.form.signatoryLastName,
        piedPage: this.piedPage,
        sign: this.signImage,
        contractToken: this.$route.params.token,
      };
      return payload;
    },

    getCompany() {
      this.$store
        .dispatch(GET_COMPANY, {
          companyToken: this.$route.params.token,
        })
        .then((response) => {
          this.form = { ...response.data[0] };
        })
        .catch(() => {
          this.$toast.add({
              summary: this.$t('toast_title_error'),
              detail: this.$t('toast_message_error'),
              severity: "error",
              life: 5000
          })
        });
    },

    goTo() {
      this.$router.push({ path: "/" });
    },
  },
  mounted() {
    this.setPiedPage();
    this.getCompany();
  },
};
</script>

<style scoped>
.pdf {
  width: 522px !important;
}

.sign {
  max-height: 100px;
  margin-top: -10px;
  margin-left: 8px;
}
</style>
